import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { DocumentDto, MsisdnDto, ResultListDto, SearchResultDocumentDto } from '../../service/dto';
import { Filter, OnTableChange, TableColumn } from '../../components/table/table.component';
import { Router } from '@angular/router';
import { HttpSubscriberService } from '../../service/http-subscriber.service';
import { finalize } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-subscriber-document-search',
	templateUrl: './subscriber-document-search.component.html',
	styleUrl: './subscriber-document-search.component.scss',
	standalone: false
})
export class SubscriberDocumentSearchComponent implements OnInit, OnDestroy {
	results?: ResultListDto<SearchResultDocumentDto>;
	loading = false;
	filterForm!: FormGroup;
	filters: Filter[] = [
		{ label: 'Document Number', name: 'documentNumber', type: 'Text', format: '^\\w+$' },
		{ label: 'Id Number', name: 'idNumber', type: 'Text', format: '^\\w+$' },
		{ label: 'Given Names', name: 'firstName', type: 'Text', format: '^\\w.*$' },
		{ label: 'Last Name', name: 'lastName', type: 'Text', format: '^\\w.*$' },
		{ label: 'Date Of Birth', name: 'dateOfBirth', type: 'Date', format: '^\\d{4}-\\d{2}-\\d{2}$' },
		{ label: 'Date Of Issue', name: 'dateOfIssue', type: 'Date', format: '^\\d{4}-\\d{2}-\\d{2}$' },
		{ label: 'Date Of Expiry', name: 'dateOfExpiry', type: 'Date', format: '^\\d{4}-\\d{2}-\\d{2}$' },
		{ label: 'Issuing Country', name: 'issuingCountry', type: 'Text', format: '^\\w+$' },
		{ label: 'Nationality', name: 'nationality', type: 'Text', format: '^\\w+$' },
		{ label: 'Place Of Birth', name: 'placeOfBirth', type: 'Text', format: '^\\w+$' },
		{ label: 'Sub Country', name: 'subCountry', type: 'Text', format: '^\\w+$' },
		{ label: 'Division', name: 'division', type: 'Text', format: '^\\w+$' },
		{ label: 'Location', name: 'location', type: 'Text', format: '^\\w+$' },
		{ label: 'Sub Location', name: 'subLocation', type: 'Text', format: '^\\w+$' }
	];



	columnRef: TableColumn[] = [
		{ "title": "ID Number", "property": "person.idNumber" },
		{ "title": "Doc Type", "property": "document.documentType" },
		{ "title": "Given Names", "cellRef": "givenNames", exportValue: item => `${item.document.firstName??''} ${item.document.secondName??''} ${item.document.otherNames??''}` },
		{ "title": "Last Name", "property": "document.lastName" },
		{ "title": "Gender", "property": "document.gender" },
		{ "title": "Date of Birth", "property": "document.dateOfBirth" },
		{ "title": "Date of Issue", "property": "document.dateOfIssue" },
		{ "title": "Date of Expiry", "property": "document.dateOfExpiry" },
		{ "title": "Place of Birth", "property": "document.placeOfBirth" },
		{ "title": "Nationality", "property": "document.nationality" },
		{ "title": "Viewable", "cellRef": "viewable", exportValue: item => `${item.hasAccess}` }
	];



	constructor(private service: HttpSubscriberService, private router: Router, private modelService: NgbModal, private formBuilder: FormBuilder) {
	}

	ngOnInit(): void {
		this.filterForm = this.formBuilder.group({
			documentNumber: ['', [Validators.pattern('^\\w+$')]],
			idNumber: ['', [Validators.pattern('^\\w+$')]],
			firstName: ['', [Validators.pattern('^\\w.*$')]],
			lastName: ['', [Validators.pattern('^\\w.*$')]],
			issuingCountry: ['', [Validators.pattern('^\\w+$')]],
			nationality: ['', [Validators.pattern('^\\w+$')]],
			placeOfBirth: ['', [Validators.pattern('^\\w+$')]],
			subCountry: ['', [Validators.pattern('^\\w+$')]],
			division: ['', [Validators.pattern('^\\w+$')]],
			location: ['', [Validators.pattern('^\\w+$')]],
			subLocation: ['', [Validators.pattern('^\\w+$')]],
			dateOfBirth: ['', [Validators.pattern('^\\d{4}-\\d{2}-\\d{2}$')]],
			dateOfIssue: ['', [Validators.pattern('^\\d{4}-\\d{2}-\\d{2}$')]],
			dateOfExpiry: ['', [Validators.pattern('^\\d{4}-\\d{2}-\\d{2}$')]],
		});
	}

	ngOnDestroy(): void {
	}

	trackByHashCode(index: number, item: SearchResultDocumentDto): any {
		return item.hashCode;
	}

	open(input: SearchResultDocumentDto) {
		if(input.hasAccess == true){
			this.router.navigate(['/subscriber', 'document-view', input.document.id]);
		}
	}
	doFetchResults(input: OnTableChange) {
		const filter: any = {
			documentNumber: input.filters.filter(i => i.name == 'documentNumber')[0]?.value,
			idNumber: input.filters.filter(i => i.name == 'idNumber')[0]?.value,
			firstName: input.filters.filter(i => i.name == 'firstName')[0]?.value,
			lastName: input.filters.filter(i => i.name == 'lastName')[0]?.value,
			dateOfBirth: input.filters.filter(i => i.name == 'dateOfBirth')[0]?.value,
			dateOfIssue: input.filters.filter(i => i.name == 'dateOfIssue')[0]?.value,
			dateOfExpiry: input.filters.filter(i => i.name == 'dateOfExpiry')[0]?.value,
			issuingCountry: input.filters.filter(i => i.name == 'issuingCountry')[0]?.value,
			nationality: input.filters.filter(i => i.name == 'nationality')[0]?.value,
			placeOfBirth: input.filters.filter(i => i.name == 'placeOfBirth')[0]?.value,
			subCountry: input.filters.filter(i => i.name == 'subCountry')[0]?.value,
			division: input.filters.filter(i => i.name == 'division')[0]?.value,
			location: input.filters.filter(i => i.name == 'location')[0]?.value,
			subLocation: input.filters.filter(i => i.name == 'subLocation')[0]?.value
		};
		this.loading = true;
		this.service.searchByDocument(filter as DocumentDto, input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = result;
			});
	}
	getFilter(name: string): Filter {
		return this.filters.filter(item => item.name == name)[0];
	}
	canOpen(input: SearchResultDocumentDto):boolean{
		return input.hasAccess;
	}
}
